import { lazy, Suspense, useEffect } from "react";
import { getCSRFToken } from "@utils/csrf";
import { useVersionCheck } from "@hooks/useVersionCheck";
import { useClientPanel } from "@hooks/useClientPanel";
import useGoogleTagManagerScript from "@hooks/helpers/useGoogleTagManagerScript";
import DCircleLoader from "@UI/components/Atoms/Loader/DCircleLoader";
const ClientRoutes = lazy(() => import("./ClientRoutes"));
const Routes = lazy(() => import("./AppRoutes"));

export function App() {
  useGoogleTagManagerScript();
  useVersionCheck();
  useEffect(() => {
    getCSRFToken();
    const interval = setInterval(() => getCSRFToken(), 300000);
    return () => clearInterval(interval);
  }, []);

  const { isClientPanel } = useClientPanel();

  return (
    <Suspense
      fallback={
        <div className="d-flex d-align-center d-justify-center d-height-100-vh">
          <DCircleLoader width="48px" height="48px" />
        </div>
      }
    >
      {isClientPanel ? <ClientRoutes /> : <Routes />}
    </Suspense>
  );
}

export default App;
